import { useState } from 'react';
import { updateBankerInterest } from '../../../services/banker.service';
import { getLoginUserData } from '../../../services/account.service';

const useExpressInterest = (updateCallback?: (dealId: string, status: string) => void) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const handleInterest = async (dealId: string, status: string) => {
    try {
      const userData = await getLoginUserData();
      const bankerId = userData.id;
      await updateBankerInterest(dealId, bankerId, status);
      setSnackbarMessage(`Interest ${status.toLowerCase()} successfully!`);
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      if (updateCallback) {
        updateCallback(dealId, status);
      }
    } catch (error: any) {
      setSnackbarMessage(error.message || 'Failed to update interest');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return {
    handleInterest,
    snackbarOpen,
    snackbarMessage,
    snackbarSeverity,
    handleSnackbarClose,
  };
};

export default useExpressInterest;
